<template>
  <template v-if="props.name">
    <input
      v-if="props.serializedValue !== undefined"
      type="hidden"
      :name="props.name"
      :value="props.serializedValue"
    />
    <template v-else>
      <input
        v-if="props.tokens.length === 0"
        type="hidden"
        :name="`${props.name}[]`"
        value=""
      />
      <input
        v-for="(token, index) in props.tokens"
        :key="token.id ?? index"
        type="hidden"
        :name="`${props.name}[]`"
        :value="token.text"
      />
    </template>
  </template>
</template>

<script setup lang="ts">
import type { DSInputToken } from "@/src/design_system/form_elements/token_input/types/props";

const props = defineProps<{
  name?: string;
  serializedValue?: string;
  tokens: DSInputToken[];
}>();
</script>
